// JS file to be used in out tailwind.config.js
// Keep this file relatively simple i.e. try not to import anything extra

/** @type {number} */
export const XSMALL_SCREEN_BREAKPOINT_PX = 455;

/** @type {number} */
export const SMALL_SCREEN_BREAKPOINT_PX = 640;

/** @type {number} */
export const MEDIUM_SCREEN_BREAKPOINT_PX = 1024;

/** @type {number} */
export const LARGE_SCREEN_BREAKPOINT_PX = 1280;

/**
 * An object representing the screen size breakpoints for responsive design.
 *
 * @typedef {Object} Breakpoints
 * @property {number} xs - The breakpoint for extra small screens, in pixels.
 * @property {number} sm - The breakpoint for small screens, in pixels.
 * @property {number} md - The breakpoint for medium screens, in pixels.
 * @property {number} lg - The breakpoint for large screens, in pixels.
 *
 * @type {Breakpoints}
 */
export const BREAKPOINTS = {
  xs: XSMALL_SCREEN_BREAKPOINT_PX,
  sm: SMALL_SCREEN_BREAKPOINT_PX,
  md: MEDIUM_SCREEN_BREAKPOINT_PX,
  lg: LARGE_SCREEN_BREAKPOINT_PX,
};
